import Table from "./Table";

import Header from "./Header";
import "./App.css";
function App() {
  return (
    <div className="App">
      <Header />
      <div className="container">
        <Table />
      </div>
    </div>
  );
}

export default App;
